/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListViewsRequest } from '../models/ListViewsRequest';
import type { ViewResponse } from '../models/ViewResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ListViewsResourceService {

    /**
     * Clones the request set of views
     * @param requestBody View ids to clone
     * @returns any The cloned views
     * @throws ApiError
     */
    public static cloneViews(
        requestBody: ListViewsRequest,
    ): CancelablePromise<{
        views: Array<ViewResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/views/clone',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Gets the requested set of views
     * @param requestBody View ids to get
     * @returns any The requested views
     * @throws ApiError
     */
    public static getViews(
        requestBody: ListViewsRequest,
    ): CancelablePromise<{
        views: Array<ViewResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/views/get',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
